































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator'
import AppDatatable from '@core/components/AppDatatable.vue'
import TheUserNavi from '@core/components/TheUserNavi.vue'
import API from '@core/services/API'
import { inject } from 'inversify-props'
import AppForm from '@core/components/AppForm.vue'
import AppRadioSelection from '@core/components/AppRadioSelection.vue'
import AppSignatureBox from '@core/components/AppSignatureBox.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import { UserMeta } from '@core/model/common/UserMeta'
import { namespace } from 'vuex-class'
import { PrincipalMetaList } from '@core/model/common/PrincipalMetaList'
import { PrincipalMeta } from '@core/model/common/PrincipalMeta'
import { SharedVariable } from '@core/model/SharedVariable'
import { IProjectSettings } from '@master/config/IProjectSettings'
import { AccountStructureMemberService } from '../api'
import { UserAdviserDetailsMeta } from './user-adviser-details-components/model/UserAdviserDetailsMeta'
import AppDialog from '@core/components/AppDialog.vue'
import { YesNoOptions } from '@master/model/options/DefaultOptions'
import { SystemRoleOptions } from '@master/model/options/SystemRoleOptions'
import { PicodedAccount } from '@core/pages/account/model/PicodedAccountDTO'

const userStore = namespace('UserStore')

@Component({
  components: {
    AppForm,
    AppRadioSelection,
    AppSignatureBox,
    AppDatatable,
    TheUserNavi,
    AppDialog
  }
})
export default class UserProfileSummary extends Vue {
  @inject()
  private projectSettings: IProjectSettings

  @inject()
  private $api: API

  @inject()
  private sharedVariable: SharedVariable

  @userStore.State
  private loading: boolean

  @userStore.State
  private user: UserMeta

  @userStore.State
  userSystem: PicodedAccount

  @userStore.State
  private userAdviserDetails: UserAdviserDetailsMeta

  @userStore.State
  private productPrincipals: PrincipalMetaList

  @userStore.Action
  private saveUser: () => Promise<void>

  @userStore.Action
  private savePassword: () => Promise<void>

  @userStore.Action
  private fetchPrincipalList: () => Promise<void>

  @userStore.Action
  private saveProductPrincipal: (principal: PrincipalMeta) => Promise<void>

  private isModalVisible = false;
  private showSignPad = false;

  private productPrincipal: PrincipalMeta = new PrincipalMeta()

  private productPrincipalColumns: Array<{ label: string; field: keyof PrincipalMeta }> = [
    { label: 'Company Name', field: 'companyDetailsName' },
    { label: 'Company Code', field: 'companyDetailsCode' },
    { label: 'Representative Code', field: 'adviserCode' }
  ];

  private userGroupsColumns: Array<object> = [
    { label: 'Group Name', field: 'names' },
    { label: 'Group Role', field: 'role' }
  ];

  private errors = [];

  private representativeBranch = ''

  get userOid (): string {
    return this.$route.params.userOid as string || this.$store.getters.currentUser.accountID
  }

  get isUserSignatureEnabled () {
    return this.sharedVariable.sysInfo?.user_signature
  }

  get isCurrentUser () {
    return this.$store.getters.currentUser._oid === this.$route.params.userOid
  }

  get isSuperUser () {
    return this.$store.getters.currentUser.isSuperUser
  }

  get productPrincipalRows () {
    return this.productPrincipals.getFullList().map(e => ({ ...e, emit: true }))
  }

  // isLockedField (key: string): boolean {
  //   const listOfLockedFields = this.userAdviserDetails.myinfoLockedFieldsClient.map(e => camelCase(e))
  //   return listOfLockedFields.includes(key)
  // }

  get userStructure (): FormStructure<UserMeta> {
    return [
      {
        label: 'Full Name',
        key: 'fullname',
        disabled: !this.isSuperUser // || this.isLockedField('fullname')
      },
      {
        label: 'System Role',
        key: 'systemrole',
        options: [
          { label: 'Adviser', value: 'adviser' },
          { label: 'Supervisor', value: 'supervisor' },
          { label: 'Director', value: 'director' },
          { label: 'Ops-Staff', value: 'ops-staff' },
          { label: 'Product Admin', value: 'product-admin' },
          { label: 'BSC Reviewer', value: 'bsc-reviewer' }
        ],
        disabled: !this.isSuperUser
      },
      {
        label: 'Old Password',
        key: 'oldPassword',
        type: 'password'
      },
      {
        label: 'New Password',
        key: 'newPassword',
        type: 'password',
        tooltip: {
          placement: 'right',
          class: 'item tooltip',
          effect: 'light',
          style: 'font-size: 18px; margin-left: 0.25rem;',
          content: `Criteria for accepted password:<br />
                    At least 8 characters<br />
                    1 special character<br />
                    1 number <br />
                    1 uppercase<br />
                    1 lowercase <br />`
        },
        icon: {
          class: 'el-icon-info'
        }
      },
      {
        label: 'Confirm New Password',
        key: 'confirmPassword',
        type: 'password'
      },
      {
        label: 'Email',
        key: 'email',
        disabled: !this.isSuperUser // || this.isLockedField('email')
      },
      {
        label: 'Mobile No.',
        key: 'mobile',
        disabled: !this.isSuperUser // || this.isLockedField('mobile')
      },
      {
        label: 'Company Code',
        key: 'companyCode',
        disabled: !this.isSuperUser
      },
      {
        label: 'RNF Number',
        key: 'masRepno',
        disabled: !this.isSuperUser
      },
      {
        label: 'Representative Branch',
        model: {
          get: () => {
            if (this.projectSettings.useNewCommissionModule) {
              return this.representativeBranch
            }

            return this.user.adviserBranch
          },
          set: (val) => {
            this.user.adviserBranch = val
          }
        },
        disabled: !this.isSuperUser || this.projectSettings.useNewCommissionModule
      },
      {
        label: 'Account Status',
        key: 'status',
        options: [
          { label: '', value: '' },
          { label: 'Active', value: 'active' },
          { label: 'Inactive', value: 'inactive' }
        ],
        disabled: !this.isSuperUser
      },
      {
        label: 'ID Doc. Type',
        key: 'idDocType',
        options: [
          { label: '', value: '' },
          { label: 'Identity Card - Pink', value: 'ic-pink' },
          { label: 'Identity Card - Blue', value: 'ic-blue' },
          { label: 'Other', value: 'others' }
        ],
        disabled: !this.isSuperUser
      },
      {
        label: 'ID No.',
        key: 'idNumber',
        disabled: !this.isSuperUser // || this.isLockedField('idNumber')
      },
      {
        label: 'With Experience',
        key: 'withExp',
        type: 'radio',
        options: YesNoOptions,
        disabled: !this.isSuperUser
      },
      {
        label: 'Product Type',
        key: 'adviserProducts',
        classes: ['colspan'],
        type: 'checkbox',
        options: [
          { label: 'Life Insurance', value: 'lifeinsurance' },
          { label: 'Investment-Linked Plans', value: 'investmentlinkedplans' },
          {
            label: 'Collective Investment Schemes (i.e. Unit Trust)',
            value: 'unittrusts'
          },
          { label: 'Accident & Health Plans', value: 'accidentandhealthplans' },
          { label: 'General Insurance', value: 'generalinsurance' },
          { label: 'Securities', value: 'securities' },
          {
            label: 'Others',
            value: 'others',
            others: {
              key: 'otherAdviserProducts',
              disabled: this.user.adviserProducts && !this.user.adviserProducts.includes('others')
            }
          }
        ],
        disabled: !this.isSuperUser
      }
    ]
  }

  get systemStructure (): FormStructure<PicodedAccount> {
    return [
      // {
      //   label: 'Username',
      //   key: 'username',
      //   disabled: !this.isSuperUser,
      //   show: this.isSuperUser
      // },
      {
        label: 'System Role',
        key: 'systemrole',
        options: SystemRoleOptions,
        disabled: !this.isSuperUser
      },
      {
        label: 'Account Status',
        key: 'status',
        options: [
          { label: '', value: '' },
          { label: 'Active', value: 'active' },
          { label: 'Inactive', value: 'inactive' }
        ],
        disabled: !this.isSuperUser
      },
      {
        label: 'Old Password',
        key: 'oldPassword',
        type: 'password'
      },
      {
        label: 'New Password',
        key: 'newPassword',
        type: 'password',
        tooltip: {
          placement: 'right',
          class: 'item tooltip',
          effect: 'light',
          style: 'font-size: 18px; margin-left: 0.25rem;',
          content: `Criteria for accepted password:<br />
                    At least 8 characters<br />
                    1 special character<br />
                    1 number <br />
                    1 uppercase<br />
                    1 lowercase <br />`
        },
        icon: {
          class: 'el-icon-info'
        }
      },
      {
        label: 'Confirm New Password',
        key: 'confirmPassword',
        type: 'password'
      }
    ]
  }

  get productPrincipalStructure (): FormStructure<PrincipalMeta> {
    return [
      {
        label: 'Company Name',
        key: 'companyDetailsName',
        disabled: true
      },
      {
        label: 'Company Code',
        key: 'companyDetailsCode',
        disabled: true
      },
      {
        label: 'Representative Code',
        key: 'adviserCode'
      }
    ]
  }

  async saveAdviserCode () {
    await this.saveProductPrincipal(this.productPrincipal)
    this.isModalVisible = false
  }

  get userGroupsRows () {
    return this.user.groups.map((userGroup) => {
      return {
        accountId: userGroup.accountID,
        names: userGroup.names[0],
        role: userGroup.role,
        redirect: '/live/group-profile/' + userGroup.accountID
      }
    })
  }

  validatePassword (): void {
    this.errors = []
    if (
      !this.user.oldPassword &&
      this.user.newPassword &&
      this.user.systemrole !== 'ops-staff'
    ) {
      this.errors.push('Old Password cannot be blank')
      return
    }
    if (
      this.user.oldPassword &&
      this.user.newPassword &&
      !this.user.confirmPassword
    ) {
      this.errors.push('Confirm Password cannot be blank')
      return
    }
    if (
      this.user.oldPassword &&
      this.user.confirmPassword !== this.user.newPassword
    ) {
      this.errors.push('Both passwords do not match')
    }
  }

  rowClick (row: PrincipalMeta): void {
    if (this.isSuperUser) {
      this.isModalVisible = true
      this.productPrincipal = row
    }
  }

  saveSignature (sign) {
    this.$api.signature.upsert({
      signature: sign
    }).then(res => {
      if (res.error) return alert(res.error)
      this.showSignPad = false
    }).catch(err =>
      alert(err)
    )
  }

  async onSubmit () {
    this.validatePassword()
    if (!this.errors.length) {
      if (!this.userSystem.newPassword) {
        this.saveUser()
        return
      }
      this.savePassword()
    }
  }

  async fetchRepresentativeBranch () {
    const res = await AccountStructureMemberService.findMemberInStructure(this.userOid)
    this.representativeBranch = res.length > 0 ? res[res.length - 1] : ''
  }

  async mounted () {
    await this.fetchPrincipalList()

    if (this.projectSettings.useNewCommissionModule) {
      await this.fetchRepresentativeBranch()
    }
  }

  async created () {
    this.$parent.$on('save', this.onSubmit)
  }
}
